import { PermissionsFinanceFeatures, PermissionsGroupName } from '@/constants/permissions';

export const financeRoutes = [
  {
    name: 'Finance',
    path: 'finance',
    redirect: { name: 'FinanceCharges' },
    meta: {
      pageTitle: 'Finance',
      permission: PermissionsGroupName.FINANCE,
    },
    component: () => import('@/layouts/EmptyRouterView.vue'),
    children: [
      {
        name: 'FinanceCharges',
        path: 'charges',
        meta: {
          pageTitle: 'Charges',
          permission: PermissionsFinanceFeatures.CHARGES,
        },
        component: () => import('@/views/finances/FinanceChargesView.vue'),
      },
      {
        name: 'FinanceInvoices',
        path: 'invoices',
        meta: {
          pageTitle: 'Invoices',
          permission: PermissionsFinanceFeatures.INVOICES,
        },
        component: () => import('@/views/finances/FinanceInvoiceView.vue'),
      },
    ],
  },
];
